import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import { isMobile } from 'react-device-detect';
import { useFlags } from 'flagsmith/react';

import { Container, Row, Col } from '@polichat/flamboyant';
import {
  ContainerMaster,
  LoginContainer,
  LoginDiv,
  LoginButtonCookies,
} from './styles';

function AuthLayout({ children, title, titleColor }) {
  // Traduções
  const privacyPolicy = useGlotaT('spa.auth.privacyPolicy');
  
  const wlState = useSelector((state) => state?.whitelabel);
  const [isWhitelabel, setIsWhitelabel] = useState(false);
  const flag = useFlags(['login_banner']);

  const imageLoginBanner = JSON.parse(flag?.login_banner?.value)?.image_link;
  const redirectLink = JSON.parse(flag?.login_banner?.value)?.redirect_link;

  useEffect(() => {
    const _isWl = wlState?.config?.is_white_label;

    if (_isWl) {
      setIsWhitelabel(_isWl);
    }
  }, [wlState]);

  const col1 = (
    <div className="banner-container">
      {isWhitelabel ? (
        <div className="login-banner" alt="Imagem do Banner"></div>
      ) : (
        <div
          className="login-banner-poli"
          style={{ backgroundImage: `url(${imageLoginBanner})` }}
          alt="Imagem de indicação"
          onClick={() => {
            window.open(redirectLink, '_blank');
          }}
        ></div>
      )}
    </div>
  );
  const col2 = (
    <LoginContainer>
      <LoginDiv>
        <a href="/login">
          <div className="form-logo"></div>
        </a>
        <span
          style={{
            color: titleColor ? titleColor : 'var(--textDefault)',
            fontSize: '32px',
          }}
        >
          {title}
        </span>
      </LoginDiv>
      {children}
      <LoginButtonCookies className="login-footer">
        {!isWhitelabel && (
          <a
            style={{ 'font-size': '14px', color: '#767676' }}
            href="https://polichat.com.br/privacidade-e-seguranca/"
          >
            {privacyPolicy}
          </a>
        )}
      </LoginButtonCookies>
    </LoginContainer>
  );

  let container = null;

  if (isMobile) {
    container = (
      <Container className="mobile">
        <Row>
          <Col sm="12">{col2}</Col>
        </Row>
      </Container>
    );
  } else {
    container = (
      <Container>
        <Row>
          <Col sm="7" className="p-0">
            {col1}
          </Col>
          <Col sm="5" className="p-0">
            {col2}
          </Col>
        </Row>
      </Container>
    );
  }
  return <ContainerMaster>{container}</ContainerMaster>;
}

export default AuthLayout;
